<template>
  <div class="character">
    <!-- 基础数据 -->
    <!-- <div class="avatar">
      <img :src="dataSource.avatar.value" alt="" />
    </div> -->
    <div class="info">
      <div class="skin-name">{{ currentLive2dType === "live2d" ? current.name.value : current.honorName.value }}</div>
      <div class="top">
        <div class="name">
          {{ dataSource.name.value }}
        </div>
        <div class="stars">
          <img
            src="@/assets/zs_imgs/star-icon.png"
            v-for="i in parseInt(dataSource.stars.value.toString().replace(/[^\d]/g, '') || '0')"
            :key="i"
          />
        </div>
      </div>
      <div class="bottom">
        <div style="display: flex; gap: 66px">
          <div class="attr attr2">
            <img :src="dataSource.attr3.icon.value" alt="" />
            <span>{{ dataSource.attr3.name.value }}</span>
          </div>
          <div class="attr attr2">
            <img :src="dataSource.attr4.icon.value" alt="" />
            <span>{{ dataSource.attr4.name.value }}</span>
          </div>
        </div>
        <div style="display: flex; gap: 42px">
          <div class="attr attr1">
            <img :src="dataSource.attr1.icon.value" alt="" />
            <span>{{ dataSource.attr1.name.value }}</span>
          </div>
          <div class="attr attr1">
            <img :src="dataSource.attr2.icon.value" alt="" />
            <span>{{ dataSource.attr2.name.value }}</span>
          </div>
        </div>
      </div>
      <div class="py-bg">
        {{ dataSource.py.value.substring(0, 7).toUpperCase() }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    },
    current: {
      type: Object,
      default: () => {
        return {};
      }
    },
    currentLive2dType: {
      type: String,
      default: "live2d"
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.character {
  position: relative;
  width: 100%;
  margin-top: 57px;

  .info {
    position: relative;
    width: 100%;
    padding-left: 11px;
    .skin-name {
      color: #b8c7dc;
      font-size: 30px;
      margin-bottom: 10px;
    }
    .py-bg {
      position: absolute;
      z-index: 0;
      top: -20px;
      left: -12px;
      font-family: SourceHanSansCN-Heavy;
      font-weight: 800;
      font-size: 152px;
      color: transparent;
      background: linear-gradient(0deg, #002d77 0%, #345487 100%);
      background-clip: text;
      opacity: 0.2;
      line-height: 152px;
      height: 152px;
      overflow: hidden;
    }
    .top {
      position: relative;
      z-index: 1;
      display: flex;
      align-items: flex-end;
      gap: 4px;
      margin-bottom: 16px;

      .name {
        font-family: SourceHanSansCN-Bold;
        font-weight: bold;
        font-size: 56px;
        line-height: 56px;
        color: transparent;
        background-image: linear-gradient(0deg, #86a5f1 0%, #ffffff 100%);
        background-clip: text;
      }
      .stars {
        display: flex;
        align-items: center;
        gap: 7px;
        width: 23px;
        height: 20px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .bottom {
      position: relative;
      z-index: 1;
      display: flex;
      align-items: center;
      gap: 185px;
      .attr {
        display: flex;
        align-items: center;
        font-family: 思源宋体;
        font-weight: 800;
        font-size: 15px;
        color: #fffffe;
        white-space: nowrap;
        overflow: hidden;
        img {
          width: 42px;
          height: 42px;
          margin-right: 12px;
        }
        span {
          font-family: 思源宋体;
        }
      }
      .attr1 {
        img {
          width: 26px;
          height: 26px;
          margin-right: 5px;
        }
      }
    }
  }
}
</style>
